export default __webpack_public_path__ + "static/media/g2.adcf1543.jpg";